import { ArrowUpRight } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { useSite } from "../context/SiteContext";
import { GALLERY_PHOTOS, track } from "../lib/site";

const EXPERIENCES = [
  { name: "Infinity Pool Hours", detail: "A temperature-controlled edge with a sunken bar, cabanas and poolside service from sunrise to starlight.", tag: "All day" },
  { name: "Dawn Nature Trails", detail: "Guided walks through orchards, wetlands and birding groves — binoculars and hot chai included.", tag: "6 AM" },
  { name: "Games Pavilion", detail: "Indoor and outdoor gaming — table tennis, carrom, badminton and lawn games for every age.", tag: "All day" },
  { name: "Yoga on the Lawn", detail: "Morning asana and pranayama sessions on the grass, led by the resort's resident instructor.", tag: "7 AM" },
  { name: "Weddings & Celebrations", detail: "Lawns, banquets and a team that has hosted hundreds of family milestones — tell us the occasion.", tag: "On request" },
  { name: "Cycling the Estate", detail: "Borrow a bicycle and trace the quiet lanes around the estate and the neighbouring villages.", tag: "All day" },
];

export default function Experiences() {
  const { openBooking } = useSite();
  return (
    <main>
      <PageHero
        image={GALLERY_PHOTOS[1]}
        eyebrow="Experiences"
        lines={[<>Days shaped</>, <em>by delight.</em>]}
        lede="Some guests plan nothing at all. For everyone else — trails, water, games and gatherings, all included or arranged on request."
      />
      <section className="section-pad intro" data-testid="experiences-list">
        <div className="experience-rows">
          {EXPERIENCES.map((item, i) => (
            <Reveal key={item.name} delay={i * 0.05} className="ritual-row" data-testid={`experience-${i}`}>
              <span className="ritual-num">{String(i + 1).padStart(2, "0")}</span>
              <div><h3>{item.name}</h3><p>{item.detail}</p></div>
              <span className="ritual-time">{item.tag}</span>
            </Reveal>
          ))}
        </div>
        <Reveal className="center-row">
          <button className="gold-button" onClick={() => { track("book_now_click", { location: "experiences_page" }); openBooking({}); }} data-testid="experiences-book-button">
            Plan your stay <ArrowUpRight size={16} />
          </button>
        </Reveal>
      </section>
    </main>
  );
}
